import React from "react";
import Select from "@/components/Select";
import useTeams from "@/hooks/useTeams";

export interface RouteToTeamValue {
  teamId: number;
}

interface Props {
  value: RouteToTeamValue;
  updateValue: (value: RouteToTeamValue) => void;
}

export default function RouteToTeamRuleForm({ value, updateValue }: Props) {
  const { teams } = useTeams();

  const teamOptions = Array.isArray(teams)
    ? teams.reduce((acc, team) => {
        acc[team.id.toString()] = team.name;
        return acc;
      }, {} as Record<string, string>)
    : {};

  return (
    <div className="space-y-2">
      <p className="text-sm text-slate-600">
        Route the conversation to a specific team when conditions match. If no
        rule matches, the widget&apos;s default team is used.
      </p>
      <Select
        options={teamOptions}
        value={value?.teamId?.toString() ?? ""}
        onChange={(v) => updateValue({ teamId: Number(v) })}
      />
      <div className="mt-3 rounded-md bg-blue-50 border border-blue-100 px-3 py-2.5 text-xs text-blue-700 leading-relaxed">
        <p className="font-semibold mb-1">Routing by survey answer</p>
        <p>
          In the <span className="font-medium">Conditions</span> panel, add an{" "}
          <span className="font-medium">Attribute</span> condition and pick a
          survey field — the variable name matches your survey field name (e.g.{" "}
          <code className="font-mono bg-blue-100 px-1 rounded">{"<<department>>"}</code>{" "}
          if your survey field is named <span className="italic">department</span>).
          Set it to <span className="font-medium">equals</span> the answer you want
          to match (e.g. <span className="italic">Sales</span>), then create one rule
          per team.
        </p>
      </div>
    </div>
  );
}
